import { Box, List, Typography, useMediaQuery, useTheme } from '@mui/material';
import LoginRightListItem from './LoginRightListItem';
import { useTranslation } from '../../hooks/useTranslation';
// import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
function LoginRightContent(props) {
	const { t } = useTranslation();
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));
	const isDark =
		props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';
	const isConsentRenewal = global.renewConsentId;

	return (
		<>
			<Box
				width={'100%'}
				sx={{
					...(isConsentRenewal && {
						paddingLeft: '0',
						paddingRight: '0',
					}),
				}}
			>
				{isConsentRenewal ? (
					<Typography
						sx={{
							textAlign: 'start',
							fontSize: '1.5rem',
							fontWeight: 600,
							mb: '0.75rem',
							fontFamily: props?.customDetails?.fontFamily,
							color:
								props.customDetails?.primaryTextColor ??
								(isDark ? '#fff' : '#000'),
							whiteSpace: { xs: 'normal', sm: 'normal', md: 'nowrap' },
							wordWrap: 'break-word',
						}}
					>
						{t('login.infographic.titleConsentRenewal')}{' '}
						<Box
							component="span"
							sx={{
								color:
									props.customDetails?.primaryTextColor ??
									(isDark ? '#fff' : props.customDetails.primaryColor),
							}}
						>
							{t('login.infographic.stepsTitleConsentRenewal')}
						</Box>
					</Typography>
				) : (
					<>
						<Typography
							sx={{
								textAlign: 'start',
								fontSize: mobileScreen ? '1rem' : '1.875rem',
								fontWeight: 700,
								mb: !mobileScreen ? '1.25rem' : '0.5rem',
								fontFamily: props?.customDetails?.fontFamily,
								color:
									props.customDetails?.primaryTextColor ??
									(isDark ? '#fff' : '#000'),
							}}
						>
							{t('login.infographic.title')}
						</Typography>
						<Typography
							sx={{
								textAlign: 'start',
								fontSize: mobileScreen ? '1.5rem' : '2.75rem',
								fontWeight: 900,
								fontFamily: props?.customDetails?.fontFamily,
								color:
									props.customDetails?.primaryTextColor ??
									(isDark ? '#fff' : props.customDetails.primaryColor),
							}}
						>
							{t('login.infographic.stepsTitle')}
						</Typography>
					</>
				)}
			</Box>
			{!isConsentRenewal && (
				<List>
					<LoginRightListItem
						number={1}
						text={t('login.infographic.step1')}
						{...props}
					/>
					<LoginRightListItem
						number={2}
						text={t('login.infographic.step2')}
						{...props}
					/>
					<LoginRightListItem
						number={3}
						text={t('login.infographic.step3')}
						{...props}
					/>
				</List>
			)}
			{isConsentRenewal && (
				<List
					sx={{
						padding: 0,
					}}
				>
					<LoginRightListItem
						isConsentRenewal={isConsentRenewal}
						number={1}
						text={t('login.infographic.consentRenewalStep1')}
						{...props}
					/>
					<LoginRightListItem
						isConsentRenewal={isConsentRenewal}
						number={2}
						text={t('login.infographic.consentRenewalStep2')}
						{...props}
					/>
					<LoginRightListItem
						isConsentRenewal={isConsentRenewal}
						number={3}
						text={t('login.infographic.consentRenewalStep3')}
						{...props}
					/>
				</List>
			)}
		</>
	);
}

export default LoginRightContent;
